module.exports = "pegasus_template/assets/theme5/medium/5.jpg";